import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    private _snackBar: MatSnackBar,
    private httpClient: HttpClient
  ) { }

  snackBarMessage(message: any, action: any) {
    this._snackBar.open(
      message,
      action,
      {
        duration: 2000
      }
    )
  }


  getThemes(data: any) {
    return this.httpClient.put(
      environment.passbookBaseUrl + `business/ssp/url`,
      data
    )
  }

  getStaffByBusiness(businessId:any,pageNo:any,size:any){
    return this.httpClient.get(
      environment.passbookBaseUrl + `staff/list/${businessId}?pageNo=${pageNo}&size=${size}`
    )
  }
  getStaffByBusinessv2(businessId:any,pageNo:any,size:any){
    return this.httpClient.get(
      environment.passbookBaseUrl + `staff/v2/list/${businessId}?pageNo=${pageNo}&size=${size}`
    )
  }

  getStaffByBusinessv3(data:any){
    return this.httpClient.put(
      environment.passbookBaseUrl + `staff/dashboard/list`,data
    )
  }

  getPlanByBusiness(businessId:any){
    return this.httpClient.get(
      environment.passbookBaseUrl + `scheme/plan/${businessId}`
    )
  }

  getPlanByBusinessV2(data:any){
    return this.httpClient.put(
      environment.passbookBaseUrl + `ext/connect/simpo/scheme/list`,data
    )
  }


    addPlan(data:any){
    return this.httpClient.post(
      environment.passbookBaseUrl + `ext/connect/simpo/create/scheme`,data
    )
  }
  
  updatePlan(planData: any){
  return this.httpClient.post(
    environment.passbookBaseUrl + `ext/connect/simpo/create/scheme`, planData);
  }
   getStoresByBusiness(businessId:any){
    return this.httpClient.get(
      environment.passbookBaseUrl + `store/business?businessId=${businessId}`
    )
  }
    UpdateBusiness(data:any){
    return this.httpClient.put(
      environment.passbookBaseUrl + `ext/connect/simpo/update/business`,data
    )
  }
 
getBusinessData(businessId: string) {
  return this.httpClient.post(
    environment.passbookBaseUrl + `ext/connect/simpo/get/business?businessId=${businessId}`,
    {} // empty body as required by the API
  );
}

 addStore(data:any){
    return this.httpClient.post(
      environment.passbookBaseUrl + `ext/connect/simpo/create/store`,data
    )
  }
}
